<template>
  <full-container>
    <div slot="header" class="tip" v-if="!id">
      <el-radio-group v-model="mode">
        <el-radio label="formpage">【表单添加】适用于公司内部客户报价</el-radio>
        <el-radio label="importpage">【批量导入】适用于政采云上询价数据批量导入</el-radio>
      </el-radio-group>
    </div>
    <component :is="mode" :id="id" />
  </full-container>
</template>

<script>
export default {
  components: {
    formpage: () => import('./form.vue'),
    importpage: () => import('./import.vue')
  },
  data () {
    return {
      mode: 'formpage',
      id: this.$route.query.id
    }
  },
}
</script>
